import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

import { Flip } from "gsap/Flip"
gsap.registerPlugin(Flip)
const socialProofBlock = document.querySelector('.block-social-proof');

// if (socialProofBlock){
//
//     gsap.set('.social-proof-content', {opacity: 0})
//
//     gsap.set('.social-proof-grid',
//         {
//             scale: 0.1,
//             opacity:0,
//             rotate: 103
//             // rotate: 180
//         })
//
//     const socialProofTL = gsap.timeline()
//
//     socialProofTL
//         .to('.social-proof-grid',
//             {
//                 rotate: 0,
//                 opacity: 1,
//                 duration: 1.2,
//                 scale: 1
//             }
//         )
//         .to('.social-proof-content',
//             {
//                 opacity: 1,
//                 stagger: 0.35,
//                 duration: 0.6
//             }
//         )
// }


const quoteBlocks = document.querySelectorAll('.block-quote');

if (quoteBlocks.length > 0) {
    quoteBlocks.forEach(quoteBlock => {

        const quoteText = quoteBlock.querySelector('h2');

        let split = SplitText.create(quoteText, {
            type: 'lines',
            mask: 'lines',
            // type: 'words',
            // mask: 'words'
        })


        gsap.set(split.lines, {y: 100, opacity: 0})
        // gsap.set(split.words, {y: 100})

        gsap.to(split.lines, {
            y: 0,
            opacity: 1,
            stagger: 0.3,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
                trigger:quoteBlock,
                start: 'top center',
                markers: false
            }
        })

    })
}


const servicesListBlock = document.querySelector('.block-services-list');

if (servicesListBlock) {

    // gsap.set('._js-service-list-card', {opacity: 0})

    ScrollTrigger.batch('._js-service-list-card img', {
        start: 'top center',
        markers: false,
        onEnter: batch => gsap.to(batch, {
            // opacity: 1,
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            duration: 1.2,
            scale: 1,
            // ease: "power2.out",
            // ease: "slow(0.7,0.7,false)",
            ease: "power1.out",
            stagger: 0.32,
        })
    })

}







// const singatures = document.querySelectorAll('.signature-wrapper')
//
// if (singatures.length > 0) {
//     console.log('here')
//     singatures.forEach(signature => {
//
//         console.log(signature)
//
//         const path = signature.querySelector('svg path');
//         const length = path.getTotalLength();
//
//         console.log(length)
//
//         path.style.strokeDasharray = length;
//         path.style.strokeDashoffset = length;
//
//         gsap.to(path, {
//             strokeDashoffset: 0,
//             duration: 5,
//             ease: 'power2.out',
//             scrollTrigger: {
//                 trigger: signature,
//                 start: 'top 80%',
//                 markers: true,
//             }
//         });
//     });
// }


//
// /*
// Landing hero
//  */
//
//
// gsap.to(".hero-image", {
//     clipPath: "inset(0% 0% 0% 0%)",
//     duration: 1.2,
//     delay: 2,
//     ease: "power3.inOut"
// })
//
// const img = document.querySelector(".hero-image");
// const heroShape = document.querySelector(".hero-shape");
// const rect = img.getBoundingClientRect();
//
// // const titleSpans = document.querySelectorAll('.hero-title')
//
// const cropSize = 144; // px
// const top = (rect.height - cropSize) / 2;
// const left = (rect.width - cropSize) / 2;
//
// const heroTL = gsap.timeline()
//
// // gsap.set('.hero-title span', {opacity: 0, y: 20})
//
// heroTL
//     .to(heroShape, { rotate: 240, duration: 1.5, ease: 'none' })
//     .to(heroShape, { scale: 0, duration: 1, ease: 'none' }, '<0.5')
//     .fromTo(img,
//         { clipPath: `inset(${top}px ${left}px ${top}px ${left}px)` },
//         { clipPath: "inset(0px 0px 0px 0px)", duration: 1.8, ease: "power3.inOut" },
//         '-=1'
//     )
//     // .to('.hero-big',
//     //     {
//     //         scale: 0, duration: 0.8, opacity: 0
//     //         }, '-=1'
//     //     )
//     // .to('.hero-title span', {
//     //     stagger: 0.2,
//     //     opacity: 1,
//     //     y: 0,
//     //     duration: 0.4
//     // },'-=0.6'
//     // )
//
// heroTL.add(() => {
//     const heroBig = document.querySelector(".hero-big")
//     const bigSpans = document.querySelectorAll(".hero-big span")
//
//     // heroBig.style.transform = "none"
//
//     // capture while still in big div at correct size/position
//     const state = Flip.getState(bigSpans, {props: 'fontSize '})
//
//     // append with no font-size override — H1 CSS applies naturally
//     const h1 = document.querySelector(".hero-title")
//     bigSpans.forEach(span => h1.append(span))
//
//     // Flip knows where they came from, animates to H1 positions
//     Flip.from(state, {
//         duration: 1.2,
//         delay: 0,
//         ease: "power3.inOut",
//         absolute: false,
//         stagger: 0.1,
//         // onStart: () => {
//         //     // font-size animates in parallel, fromTo so it's explicit
//         //     gsap.fromTo(bigSpans,
//         //         { fontSize: "110px" },
//         //         {
//         //             fontSize: "24px",
//         //             duration: 1.2,
//         //             ease: "power3.inOut",
//         //             stagger: 0.05,
//         //             onComplete: () => {
//         //                 bigSpans.forEach(span => span.style.fontSize = "")
//         //             }
//         //         }
//         //     )
//         // }
//     })
// }, '-=1')
//
// gsap.set(img, { clipPath: `inset(${top}px ${left}px ${top}px ${left}px)` })
//
// gsap.fromTo(img,
//     { clipPath: `inset(${top}px ${left}px ${top}px ${left}px)` },
//     { clipPath: "inset(0px 0px 0px 0px)", duration: 2.2, ease: "power3.inOut" }
// )



/*
Feature block
 */

// const featureBlocks = document.querySelectorAll('.block-feature');
//
// if (featureBlocks.length > 0){
//
//     featureBlocks.forEach(block=>{
//
//         const text = block.querySelector('._js-feautre-text')
//         const blockHeight = block.offsetHeight;
//         console.log(text)
//
//         let split = SplitText.create(text, {
//             type: 'chars',
//             // type: 'words',
//             // mask: 'words'
//         })
//
//         const group1 = split.chars.filter((_, i) => i % 3 === 0); // 0, 3, 6...
//         const group2 = split.chars.filter((_, i) => i % 3 === 1); // 1, 4, 7...
//         const group3 = split.chars.filter((_, i) => i % 3 === 2); // 2, 5, 8...
//
//         gsap.set(group1, { y: 0 });
//         gsap.set(group3, { y: blockHeight * -0.32 });
//         gsap.set(group2, { y: blockHeight * -0.58 });
//
//
//         gsap.to(split.chars,{
//             y: 0,
//             scrollTrigger: {
//                 trigger:block,
//                 start: 'top top',
//                 markers: false,
//                 scrub: 0.7,
//                 pin: true
//             }
//         })
//
//     })
//
// }

// import fitty from 'fitty';
// fitty('._js-feautre-text', { maxSize: 170 });




/*
Header
 */


const header = document.querySelector("header.site-header");
const hero = document.querySelector("._js-hero");
const isOverlayTemplate =
    document.body.classList.contains("page-template-template-landing") ||
    document.body.classList.contains("page-template-template-about-us") ||
    document.body.classList.contains("single-service");

if (header && hero && isOverlayTemplate) {
    ScrollTrigger.create({
        trigger: hero,
        start: "bottom top",

        onEnter: () => {
            header.classList.add("is-sticky");

            gsap.from(header, {
                yPercent: -100,
                duration: 0.45,
                ease: "power2.out",
            });
        },

        onLeaveBack: () => {
            gsap.to(header, {
                yPercent: -100,
                duration: 0.3,
                ease: "power2.in",
                onComplete: () => {
                    header.classList.remove("is-sticky");
                    gsap.set(header, { clearProps: "transform" });
                },
            });
        },
    });
}